import { useState } from 'react';
import I18n from 'I18n';
import { Flex } from 'foundations-components/components/Flex';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
import { RemoveIcon } from 'foundations-assets/icons/components/RemoveIcon';
import { useSetUserDecisionV2Mutation } from '../../../__generated__/chirp/com/hubspot/ai/context/mining/rpc/TranscriptPropertyUpdateSuggestionsService.hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function MilestoneSuggestionActions({
  suggestion,
  onResolved,
  onError
}) {
  const [pendingDecision, setPendingDecision] = useState(null);
  const [setUserDecision, {
    error
  }] = useSetUserDecisionV2Mutation();
  const handleDecision = async decisionStatus => {
    setPendingDecision(decisionStatus);
    try {
      var _result$errors;
      const result = await setUserDecision({
        variables: {
          runId: suggestion.runId,
          objectTypeId: suggestion.targetObjectTypeId,
          objectId: suggestion.targetObjectId,
          suggestionDecisionInputs: [{
            propertyName: suggestion.propertyName,
            decisionStatus
          }]
        }
      });
      if ((_result$errors = result.errors) !== null && _result$errors !== void 0 && _result$errors.length) {
        onError === null || onError === void 0 || onError(decisionStatus);
      } else {
        await (onResolved === null || onResolved === void 0 ? void 0 : onResolved(decisionStatus));
      }
    } catch (_unused) {
      // mutation failed; suggestion stays visible
      onError === null || onError === void 0 || onError(decisionStatus);
    } finally {
      setPendingDecision(null);
    }
  };
  const isLoading = pendingDecision !== null;
  return /*#__PURE__*/_jsxs(Flex, {
    children: [/*#__PURE__*/_jsx(Tooltip, {
      title: I18n.text('dealPlan.milestones.suggestion.approve'),
      children: /*#__PURE__*/_jsx(LoadingButton, {
        "data-test-id": "milestone-suggestion-approve",
        "aria-label": I18n.text('dealPlan.milestones.suggestion.approve'),
        failed: !!error,
        disabled: isLoading,
        loading: pendingDecision === 'APPROVED',
        onClick: () => {
          void handleDecision('APPROVED');
        },
        padding: "100",
        use: "tertiary-light",
        size: "xs",
        responsive: false,
        children: /*#__PURE__*/_jsx(SuccessIcon, {})
      })
    }), /*#__PURE__*/_jsx(Tooltip, {
      title: I18n.text('dealPlan.milestones.suggestion.reject'),
      children: /*#__PURE__*/_jsx(LoadingButton, {
        "data-test-id": "milestone-suggestion-reject",
        "aria-label": I18n.text('dealPlan.milestones.suggestion.reject'),
        failed: !!error,
        disabled: isLoading,
        loading: pendingDecision === 'REJECTED',
        onClick: () => {
          void handleDecision('REJECTED');
        },
        padding: "100",
        use: "tertiary-light",
        size: "xs",
        responsive: false,
        children: /*#__PURE__*/_jsx(RemoveIcon, {})
      })
    })]
  });
}